import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicFormControls, BaasicButton, DatePickerField, BasicInput } from 'core/components';
function NikoPatientInsuranceEditTemplate({ nikoPatientInsuranceEditViewStore, t }) {
  const {
    form,
    insuranceStore,
    relationshipStore,
    genderStore,
    isEditAction,
    isChangeAction,
    title,
    pageViewStore,
  } = nikoPatientInsuranceEditViewStore;

  const relationship = form.$('relationship').value;
  const showInsuredPersonFields = relationship === 'Spouse' || relationship === 'Parent' || relationship === 'Other';
  const showEmployerField = relationship === 'Employer';
  const oldEndDateUnavailable = form.$('oldEndDateUnavailable').value;

  return (
    <form onSubmit={form.onSubmit}>
      {isChangeAction &&
        <div className="modal__body">
          <div className="row u-flex--align-end">
            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
              <DatePickerField field={form.$('oldEndDate')} disabled={oldEndDateUnavailable || form.submitting || form.validating} />
            </div>
            <div className="form__group col col-lrg-6 u-mar--bottom--med-lrg">
              <label className="form__group__label--checkbox">
                <input
                  type="checkbox"
                  id="oldEndDateUnavailable"
                  className="input--check"
                  checked={oldEndDateUnavailable || false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    form.$('oldEndDateUnavailable').set('value', checked);
                    form.$('oldEndDate').set('rules', checked ? '' : 'required');
                    form.$('oldEndDate').validate();
                  }}
                />
                <label htmlFor="oldEndDateUnavailable">End Date Unavailable</label>
              </label>
            </div>
          </div>
        </div>
      }
      <div className="modal__header">
        <h3 className='modal__header__title'>{title}</h3>
      </div>
      <div className="modal__body">
        <div className="row">
          <div className="form__group col col-lrg-6 u-mar--bottom--sml">
            <BaasicFieldDropdown field={form.$('insuranceId')} store={insuranceStore} allowEmpty={true} disabled={isEditAction} />
          </div>
          <div className="form__group col col-lrg-6 u-mar--bottom--sml">
            <BasicInput field={form.$('policyNo')} />
          </div>
          <div className="form__group col col-lrg-6 u-mar--bottom--sml">
            <DatePickerField field={form.$('startDate')} disabled={form.submitting || form.validating} />
          </div>
          <div className="form__group col col-lrg-6 u-mar--bottom--sml">
            <DatePickerField field={form.$('endDate')} disabled={form.submitting || form.validating} />
          </div>
          <div className="form__group col col-lrg-6 u-mar--bottom--sml">
            <BaasicFieldDropdown field={form.$('relationship')} store={relationshipStore} />
          </div>
          {showInsuredPersonFields && (
            <React.Fragment>
              <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                <BasicInput field={form.$('insuredFirstName')} />
              </div>
              <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                <BasicInput field={form.$('insuredLastName')} />
              </div>
              <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                <DatePickerField field={form.$('insuredDOB')} customFormat={"MM/dd/yyyy"} formatPlaceholder={{ year: "yyyy", month: "mm", day: "dd" }} disabled={form.submitting || form.validating} />
              </div>
              <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                <BaasicFieldDropdown field={form.$('insuredGender')} store={genderStore} />
              </div>
            </React.Fragment>
          )}
          {showEmployerField && (
            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
              <BasicInput field={form.$('insuredLastName')} />
            </div>
          )}
        </div>
      </div>
      <div className='modal__footer'>
        <BaasicButton
          className='btn btn--med btn--light'
          disabled={form.submitting || form.validating || pageViewStore.disabled}
          label={t('EDIT_FORM_LAYOUT.CANCEL')}
          onClick={() => pageViewStore.closeAll()}
        />
        <BaasicFormControls
          className='btn btn--med btn--primary'
          form={form}
          onSubmit={form.onSubmit}
          disabled={form.submitting || form.validating || pageViewStore.disabled}
          label="Save"
        />
      </div>
    </form>
  )
}

NikoPatientInsuranceEditTemplate.propTypes = {
  nikoPatientInsuranceEditViewStore: PropTypes.object,
  t: PropTypes.func,
};

export default defaultTemplate(NikoPatientInsuranceEditTemplate);